var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/PlansAndPricingMenu.js",
  _this = this;
import React from 'react';
import { createURL } from '@sm/utils';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import Menu from './components/Menu.js';
import { plansPricingMenu } from '../../config/linkInfo';
export var PlansAndPricingMenu = function PlansAndPricingMenu() {
  var path = createURL('/pricing/', {
    ut_source: 'megamenu'
  });
  var key = 'Plans & Pricing';
  var handleMenuClick = function handleMenuClick() {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'review session landing page clicked pricingcta',
        interactionType: 'click'
      }
    });
  };
  return /*#__PURE__*/React.createElement(Menu, Object.assign({}, plansPricingMenu(), {
    path: path,
    menuKey: key,
    onClick: handleMenuClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }));
};
export default PlansAndPricingMenu;
//# sourceMappingURL=PlansAndPricingMenu.js.map